import { Notification } from "./Notification";
import { v4 as uuidv4 } from "uuid";

/**
 * @typedef {{
 *  arrayMatrix__referenceFrame_robotKinematicsChainRoot: ArrayMatrix,
 *  arrayMatrix__referenceFrame_world: ArrayMatrix,
 *   uuid: UUID | undefined,
 *   vid: VID
 * }} CalibrationPartData
 * @typedef {import("./Config").Config} Config
 * @typedef {import("../types").UUID} UUID
*/

/** @type ArrayMatrix */
const Identity = [1,0,0,0,  0,1,0,0,  0,0,1,0,  0,0,0,1];

/**
 * @param {Config} pConfig
 * @param {{parameters: CalibrationPartData}} pData
 */
export function CalibrationPart(pConfig, pData) {
  Notification.call(this);

  this.arrayMatrix__referenceFrame_robotKinematicsChainRoot = [...Identity];
  this.arrayMatrix__referenceFrame_world = [...Identity];
  this.mConfig = pConfig;
  this.mName = '';
  this.mAssociatedApplicationIds = [];
  this.mUUID = '';
  this.mVID = '';
  this.mSelectedInConfig = false;

  this.fromJson(pData);
}

CalibrationPart.prototype = Object.create(Notification.prototype);
CalibrationPart.prototype.constructor = CalibrationPart;

CalibrationPart.prototype.setDirty = function() {
  // WARNING : This function is overridden in the assembler (vention_assembler/client/src/machinelogic.js)
  this.mConfig.setDirty();
};

CalibrationPart.prototype.getConfig = function() {
  return this.mConfig;
};

CalibrationPart.prototype.getConfigManager = function() {
  return this.mConfig.getConfigManager();
};

/**
 * Returns the Controller that this input belongs to.
 * @returns {UUID} Unique ID of the controller.
 */
CalibrationPart.prototype.getControllerId = function() {
  return this.mConfig.getController().getUUID();
};

CalibrationPart.prototype.getUUID = function() {
  return this.mUUID;
};

CalibrationPart.prototype.getName = function() {
  return this.mName;
};

CalibrationPart.prototype.setName = function(pName) {
  this.mname = pName;
  this.setDirty();

};

/**
 * @param {UUID} appID
 * @returns {boolean} true if the appID was added to the list of apps using this CalibrationPart
 */
CalibrationPart.prototype.addApplicationUUID = function(appUUID) {
  if ( !this.mAssociatedApplicationIds.includes(appUUID) ) {
    this.mAssociatedApplicationIds.push(appUUID);
    this.setDirty();
    return true;
  }

  return false;
};

/**
 * @param {UUID} appUUID
 * @returns {boolean} true if the appID was removed for the list of apps using this CalibrationPart
 */
CalibrationPart.prototype.removeApplicationUUID = function(appUUID) {
  const beforeCnt = this.mAssociatedApplicationIds.length;
  this.mAssociatedApplicationIds = this.mAssociatedApplicationIds.filter(pUUID => pUUID !== appUUID );

  if ( beforeCnt !== this.mAssociatedApplicationIds.length ) {
    this.setDirty();
    return true;
  }

  return false;
};

/**
 * @param {CalibrationPartData} pData
 * @returns {boolean} True if the given data has the same UUID or VID as this CalibrationPart.
 */
CalibrationPart.prototype.hasSameUUIDOrVID = function(pData) {
  return (pData && (pData.uuid === this.mUUID || pData.vid === this.mVID) );
};


/**
 * @returns {boolean}
 */
CalibrationPart.prototype.isSelectedInConfig = function() {
  return this.mSelectedInConfig;
};

/**
 * @returns {boolean}
 */
CalibrationPart.prototype.isValid = function() {
  return true;
};

CalibrationPart.prototype.toJson = function() {
  return {
    'category': 'config',
    'name': 'calibrationPart',
    'parameters': {
      'aliasName': this.mName, // TODO RR: Should this be 'name'?
      'arrayMatrix__referenceFrame_robotKinematicsChainRoot': this.arrayMatrix__referenceFrame_robotKinematicsChainRoot,
      'arrayMatrix__referenceFrame_world': this.arrayMatrix__referenceFrame_world,
      'controllerId': this.mConfig.getController().getUUID(),
      'associatedApplicationIds': this.mAssociatedApplicationIds,
      'uuid': this.mUUID,
      'vid': this.mVID,
      isSelectedInConfig: this.mSelectedInConfig,
    }
  };
};


CalibrationPart.prototype.fromJson = function(pInstruction) {
  if(pInstruction && pInstruction.parameters) {
    const params = pInstruction.parameters;
    this.arrayMatrix__referenceFrame_robotKinematicsChainRoot = params.arrayMatrix__referenceFrame_robotKinematicsChainRoot || [...Identity];
    this.arrayMatrix__referenceFrame_world = params.arrayMatrix__referenceFrame_world || [...Identity];
    this.mName = params.aliasName || this.mName;
    this.mAssociatedApplicationIds = params.associatedApplicationIds || [];
    this.mUUID = params.uuid || uuidv4();
    this.mVID = params.vid || undefined;
    this.mSelectedInConfig = params.isSelectedInConfig || false;
  }
};
